import { styled } from '@mui/material'
import { DiscussionThread } from './DiscussionThread'
import { InteractiveVersionSeparator } from './VersionSeparator'
import { Discussion } from '../../../../../domain/entity/DiscussionEntity'
import { intl } from '../../../../../i18n'
import { EmptyMessage, ThreadListContainer } from './panelStyles'

type PastVersionSectionProps = {
  versionName: string
  threadCount?: number
  discussion: Discussion | undefined
  isExpanded: boolean
  isLoading: boolean
  onToggle: () => void
  projectUuid: string
  versionPageUuid: string
}

export const PastVersionSection = ({
  versionName,
  threadCount,
  discussion,
  isExpanded,
  isLoading,
  onToggle,
  projectUuid,
  versionPageUuid,
}: PastVersionSectionProps) => {
  const threads = discussion
    ? [...discussion.discussionThreads].sort(
        (a, b) => b.createdAt - a.createdAt
      )
    : []

  return (
    <VersionGroup>
      <InteractiveVersionSeparator
        versionName={versionName}
        threadCount={threadCount}
        isExpanded={isExpanded}
        isLoading={isLoading}
        onToggle={onToggle}
      />
      {isExpanded && !isLoading && (
        <ThreadListContainer>
          {threads.length === 0 ? (
            <EmptyMessage>
              {intl.formatMessage({ id: 'discussion.empty' })}
            </EmptyMessage>
          ) : (
            threads.map(thread => (
              <DiscussionThread
                key={thread.threadUuid}
                thread={thread}
                projectUuid={projectUuid}
                versionPageUuid={versionPageUuid}
                onRefresh={() => undefined}
                readOnly={true}
              />
            ))
          )}
        </ThreadListContainer>
      )}
    </VersionGroup>
  )
}

const VersionGroup = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})
